module.exports = __webpack_public_path__ + "static/media/dark-theme-neutral-driving.c8d9f7d5.svg";